
import {InternalBeltState} from './internal-belt-state';
import {ModuleDefinition} from './module-definition';
import {NotificationEntry} from './notificationEntry';
import {Guid} from 'guid-typescript';
import {Wards} from './wards';
import {SetupTask} from './setup-task';
import {ModuleGlobalState} from './enums/module-global-state.enum';
import {ModuleInventoryInfo} from './module-inventory-info';

export class CustomerModule {
  public Customer: string;
  public SerialNumber: string;
  public Module: ModuleDefinition;
  public CurrentRevision = 0;
  public UpdateRevision = 0;
  public InternalBeltStates: InternalBeltState[];
  public ActiveErrorNotifications: NotificationEntry[];
  public ActiveWarningNotifications: NotificationEntry[];
  public Initialized = false;
  public FullyConfigured = false;
  public SerialNumberSetted = false;
  public CustomerModuleId: string;
  public NodeIpAddress: string;
  public Comment: string;
  public Owner: string;
  public OwnerName: string;
  public Holder: string;
  public HolderName: string;
  public Ward: Wards;
  public ActiveTasks: SetupTask[];
  public ModuleGlobalState = ModuleGlobalState.Unknown;
  public ModuleSSID: string;
  public InventoryInfo: ModuleInventoryInfo;
  public SafetyConfigActive = false;

  constructor(customer: string, serialNumber: string, module: ModuleDefinition) {
    this.Customer = customer;
    this.SerialNumber = serialNumber;
    this.Module = module;
    this.ActiveErrorNotifications = [];
    this.ActiveWarningNotifications = [];
  }

  public SetId() {
    this.CustomerModuleId = Guid.create().toString();
  }

  public ResetSetupTasks() {
    if (this.ActiveTasks) {
      // this.ActiveTasks = null;

      for (const tk of this.ActiveTasks) {
        tk.Done = false;
      }

      this.Module.ServiceTaskRequired = true;
    } else {
      this.Module.ServiceTaskRequired = false;
    }
  }

  public CheckServiceTasks() {
    this.Module.ServiceTaskRequired = false;
    if (this.ActiveTasks) {
      for (const task of this.ActiveTasks) {
        if (task.Done === false) {
          this.Module.ServiceTaskRequired = true;
          return;
        }
      }
    }
  }



  public Copy(): CustomerModule {
    const cst = new CustomerModule(this.Customer, this.SerialNumber, this.Module.Copy());
    cst.ActiveWarningNotifications = this.ActiveWarningNotifications;
    cst.ActiveErrorNotifications = this.ActiveErrorNotifications;
    cst.SerialNumberSetted = this.SerialNumberSetted;
    cst.SerialNumber = this.SerialNumber;
    cst.InternalBeltStates = this.InternalBeltStates;
    cst.Initialized = this.Initialized;
    cst.CustomerModuleId = this.CustomerModuleId;
    cst.Comment = this.Comment;
    cst.Owner = this.Owner;
    cst.OwnerName = this.OwnerName;
    cst.Holder = this.Holder;
    cst.HolderName = this.HolderName;
    cst.Ward = this.Ward;

    return cst;
  }
}
